import React from 'react';
import PropTypes from 'prop-types';
import Modal from '@domain-group/fe-co-modal';
import AllhomesApi, { AuthenticationState } from '@domain-group/fe-co-allhomes-api';
import AllhomesLogo from '@domain-group/fe-co-allhomes-logo';
import SignInPage from './components/sign-in';
import SignUpPage from './components/sign-up';
import ForgotPasswordPage from './components/forgot-password';
import ResetPasswordPage from './components/reset-password';
import EuUserPage from './components/eu-user';
import * as styles from './allhomes-authentication.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var CLOSED = AuthenticationState.CLOSED,
  SIGN_IN = AuthenticationState.SIGN_IN,
  SIGN_UP = AuthenticationState.SIGN_UP,
  RETRIEVE_PASSWORD = AuthenticationState.RETRIEVE_PASSWORD,
  RESET_PASSWORD = AuthenticationState.RESET_PASSWORD,
  EU_PAGE = AuthenticationState.EU_PAGE;
var BaseAllhomesAuthentication = _ref => {
  var username = _ref.username,
    token = _ref.token,
    currentPage = _ref.currentPage,
    signInType = _ref.signInType,
    onCloseModal = _ref.onCloseModal,
    isEuUser = _ref.isEuUser,
    error = _ref.error,
    onOptIn = _ref.onOptIn,
    onSignIn = _ref.onSignIn,
    onSignUp = _ref.onSignUp,
    onRetrievePassword = _ref.onRetrievePassword,
    onResetPassword = _ref.onResetPassword,
    onSwitchPage = _ref.onSwitchPage,
    onResendActivation = _ref.onResendActivation,
    allhomesUrl = _ref.allhomesUrl;
  var openForgotPassword = defaultUsername => onSwitchPage(RETRIEVE_PASSWORD, {
    username: defaultUsername
  });
  var openSignUp = defaultUsername => onSwitchPage(SIGN_UP, {
    username: defaultUsername
  });
  var openSignIn = defaultUsername => onSwitchPage(SIGN_IN, {
    username: defaultUsername
  });

  /* eslint-disable jsx-a11y/no-static-element-interactions */
  return ___EmotionJSX("section", {
    css: styles.modal
  }, currentPage !== CLOSED && ___EmotionJSX(Modal, {
    animated: false,
    appearance: "standard",
    closeCallback: onCloseModal,
    style: {
      padding: 0
    },
    width: "100%",
    innerStyle: {
      borderRadius: 0,
      width: '100%',
      height: '100%',
      maxWidth: '100%'
    }
  }, ___EmotionJSX("div", {
    css: styles.container
  }, ___EmotionJSX("div", {
    css: styles.headerSection
  }, ___EmotionJSX("a", {
    href: allhomesUrl,
    tabIndex: 0
  }, ___EmotionJSX(AllhomesLogo, null))), currentPage === SIGN_IN && ___EmotionJSX(SignInPage, {
    initialUsername: username,
    onForgotPasswordClick: openForgotPassword,
    onSignInClick: onSignIn,
    onSignUpClick: openSignUp,
    isEuUser: isEuUser,
    error: error,
    signInType: signInType,
    onResendActivationClick: onResendActivation,
    onCloseModalCallback: onCloseModal
  }), currentPage === EU_PAGE && ___EmotionJSX(EuUserPage, {
    onOptIn: onOptIn,
    error: error,
    onCloseModalCallback: onCloseModal
  }), currentPage === SIGN_UP && ___EmotionJSX(SignUpPage, {
    onCloseModalCallback: onCloseModal,
    onSignInClick: openSignIn,
    onSignUpClick: onSignUp,
    onForgotPasswordClick: openForgotPassword,
    initialUsername: username,
    error: error
  }), currentPage === RETRIEVE_PASSWORD && ___EmotionJSX(ForgotPasswordPage, {
    initialUsername: username,
    onCloseModalCallback: onCloseModal,
    onSignInClick: openSignIn,
    onRetrievePasswordClick: onRetrievePassword,
    error: error
  }), currentPage === RESET_PASSWORD && ___EmotionJSX(ResetPasswordPage, {
    username: username,
    token: token,
    onSaveClick: onResetPassword,
    error: error,
    onCloseModalCallback: onCloseModal
  }))));
};
BaseAllhomesAuthentication.propTypes = {
  currentPage: PropTypes.string,
  signInType: PropTypes.shape({
    title: PropTypes.string,
    subtitle: PropTypes.string,
    type: PropTypes.string
  }),
  username: PropTypes.string,
  token: PropTypes.string,
  error: PropTypes.arrayOf(PropTypes.shape({})),
  onCloseModal: PropTypes.func,
  onSwitchPage: PropTypes.func,
  onSignIn: PropTypes.func,
  onSignUp: PropTypes.func,
  onOptIn: PropTypes.func,
  onRetrievePassword: PropTypes.func,
  onResetPassword: PropTypes.func,
  isEuUser: PropTypes.bool,
  onResendActivation: PropTypes.func,
  allhomesUrl: PropTypes.string
};
BaseAllhomesAuthentication.defaultProps = {
  currentPage: AuthenticationState.CLOSED,
  signInType: undefined,
  error: [],
  username: undefined,
  token: undefined,
  isEuUser: false,
  onCloseModal: () => {},
  onSwitchPage: () => {},
  onSignIn: () => Promise.resolve(),
  onOptIn: () => Promise.resolve(),
  onSignUp: () => Promise.resolve(),
  onRetrievePassword: () => Promise.resolve(),
  onResetPassword: () => Promise.resolve(),
  onResendActivation: () => Promise.resolve(),
  allhomesUrl: 'https://www.allhomes.com.au'
};
var AllhomesAuthentication = () => ___EmotionJSX(AllhomesApi, null, context => {
  var isEuUser = context.isEuUser,
    authentication = context.authentication,
    closeAuth = context.closeAuth;
  return authentication ? ___EmotionJSX(BaseAllhomesAuthentication, {
    signInType: authentication.signInType,
    isEuUser: isEuUser,
    error: authentication.error,
    username: authentication.username,
    token: authentication.token,
    currentPage: authentication.currentPage,
    onCloseModal: closeAuth,
    onSwitchPage: authentication.actions.switchPage,
    onSignIn: authentication.actions.signIn,
    onSignUp: authentication.actions.signUp,
    onRetrievePassword: authentication.actions.retrievePassword,
    onResetPassword: authentication.actions.resetPassword,
    onOptIn: authentication.actions.optIn,
    onResendActivation: authentication.actions.resendActivation
  }) : null;
});
export { BaseAllhomesAuthentication };
export default AllhomesAuthentication;